import React from "react";
import constants from "../constants";

export default function TopicSvgIcon(Props) {
  return Props.icon === constants.TOPICS.ITERATIONS ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30666)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#F96343"
          d="M13.075 18.3998C13.0767 16.9084 13.6698 15.4786 14.7244 14.4241C15.7789 13.3696 17.2087 12.7764 18.7 12.7748H27.1914L26.3828 11.9669C26.2656 11.8497 26.1997 11.6906 26.1997 11.5248C26.1997 11.3589 26.2656 11.1998 26.3828 11.0826C26.5001 10.9653 26.6592 10.8994 26.825 10.8994C26.9909 10.8994 27.1499 10.9653 27.2672 11.0826L29.1422 12.9576C29.2003 13.0156 29.2464 13.0846 29.2779 13.1604C29.3093 13.2363 29.3255 13.3176 29.3255 13.3998C29.3255 13.4819 29.3093 13.5632 29.2779 13.6391C29.2464 13.715 29.2003 13.7839 29.1422 13.8419L27.2672 15.7169C27.1499 15.8342 26.9909 15.9001 26.825 15.9001C26.6592 15.9001 26.5001 15.8342 26.3828 15.7169C26.2656 15.5997 26.1997 15.4406 26.1997 15.2748C26.1997 15.1089 26.2656 14.9498 26.3828 14.8326L27.1914 14.0248H18.7C17.5401 14.026 16.428 14.4873 15.6078 15.3075C14.7876 16.1277 14.3263 17.2398 14.325 18.3998C14.325 18.5655 14.2592 18.7245 14.142 18.8417C14.0247 18.9589 13.8658 19.0248 13.7 19.0248C13.5343 19.0248 13.3753 18.9589 13.2581 18.8417C13.1409 18.7245 13.075 18.5655 13.075 18.3998ZM28.7 17.7748C28.5343 17.7748 28.3753 17.8406 28.2581 17.9578C28.1409 18.075 28.075 18.234 28.075 18.3998C28.0738 19.5597 27.6124 20.6718 26.7922 21.492C25.972 22.3122 24.86 22.7735 23.7 22.7748H15.2086L16.0172 21.9669C16.0753 21.9089 16.1213 21.8399 16.1528 21.7641C16.1842 21.6882 16.2004 21.6069 16.2004 21.5248C16.2004 21.4426 16.1842 21.3613 16.1528 21.2855C16.1213 21.2096 16.0753 21.1406 16.0172 21.0826C15.9591 21.0245 15.8902 20.9784 15.8143 20.947C15.7385 20.9156 15.6571 20.8994 15.575 20.8994C15.4929 20.8994 15.4116 20.9156 15.3357 20.947C15.2598 20.9784 15.1909 21.0245 15.1328 21.0826L13.2578 22.9576C13.1997 23.0156 13.1536 23.0845 13.1222 23.1604C13.0907 23.2363 13.0745 23.3176 13.0745 23.3998C13.0745 23.4819 13.0907 23.5632 13.1222 23.6391C13.1536 23.715 13.1997 23.7839 13.2578 23.8419L15.1328 25.7169C15.1909 25.775 15.2598 25.8211 15.3357 25.8525C15.4116 25.8839 15.4929 25.9001 15.575 25.9001C15.6571 25.9001 15.7385 25.8839 15.8143 25.8525C15.8902 25.8211 15.9591 25.775 16.0172 25.7169C16.0753 25.6589 16.1213 25.5899 16.1528 25.5141C16.1842 25.4382 16.2004 25.3569 16.2004 25.2748C16.2004 25.1926 16.1842 25.1113 16.1528 25.0355C16.1213 24.9596 16.0753 24.8906 16.0172 24.8326L15.2086 24.0248H23.7C25.1913 24.0231 26.6211 23.4299 27.6757 22.3754C28.7302 21.3209 29.3234 19.8911 29.325 18.3998C29.325 18.234 29.2592 18.075 29.142 17.9578C29.0247 17.8406 28.8658 17.7748 28.7 17.7748Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30666"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30666"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30666"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30666"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30666"
            result="effect2_dropShadow_9470_30666"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30666"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.PATTERNS ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30671)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#F96343"
          d="M17.45 11.5249C16.8319 11.5249 16.2278 11.7082 15.7139 12.0516C15.2 12.3949 14.7994 12.883 14.5629 13.454C14.3264 14.025 14.2645 14.6534 14.3851 15.2596C14.5056 15.8658 14.8033 16.4226 15.2403 16.8596C15.6773 17.2967 16.2342 17.5943 16.8404 17.7149C17.4465 17.8354 18.0749 17.7736 18.6459 17.537C19.2169 17.3005 19.705 16.9 20.0484 16.3861C20.3917 15.8722 20.575 15.268 20.575 14.6499C20.575 13.8211 20.2458 13.0262 19.6597 12.4402C19.0737 11.8541 18.2788 11.5249 17.45 11.5249ZM17.45 16.5249C17.0792 16.5249 16.7167 16.4149 16.4083 16.2089C16.1 16.0029 15.8597 15.71 15.7177 15.3674C15.5758 15.0248 15.5387 14.6478 15.611 14.2841C15.6834 13.9204 15.862 13.5863 16.1242 13.3241C16.3864 13.0619 16.7205 12.8833 17.0842 12.8109C17.4479 12.7386 17.8249 12.7757 18.1675 12.9176C18.5102 13.0595 18.803 13.2999 19.009 13.6082C19.215 13.9166 19.325 14.2791 19.325 14.6499C19.325 15.1472 19.1275 15.6241 18.7758 15.9757C18.4242 16.3274 17.9473 16.5249 17.45 16.5249ZM24.95 17.7749C25.5681 17.7749 26.1723 17.5916 26.6862 17.2482C27.2001 16.9049 27.6006 16.4168 27.8371 15.8458C28.0737 15.2748 28.1355 14.6464 28.015 14.0402C27.8944 13.4341 27.5968 12.8772 27.1597 12.4402C26.7227 12.0032 26.1659 11.7055 25.5597 11.5849C24.9535 11.4644 24.3251 11.5263 23.7541 11.7628C23.1831 11.9993 22.6951 12.3998 22.3517 12.9137C22.0083 13.4277 21.825 14.0318 21.825 14.6499C21.825 15.4787 22.1543 16.2736 22.7403 16.8596C23.3264 17.4457 24.1212 17.7749 24.95 17.7749ZM24.95 12.7749C25.3209 12.7749 25.6834 12.8849 25.9917 13.0909C26.3 13.2969 26.5404 13.5898 26.6823 13.9324C26.8242 14.275 26.8613 14.652 26.789 15.0157C26.7166 15.3794 26.5381 15.7135 26.2758 15.9757C26.0136 16.238 25.6795 16.4165 25.3158 16.4889C24.9521 16.5612 24.5751 16.5241 24.2325 16.3822C23.8899 16.2403 23.597 15.9999 23.391 15.6916C23.185 15.3833 23.075 15.0207 23.075 14.6499C23.075 14.1526 23.2726 13.6757 23.6242 13.3241C23.9758 12.9724 24.4527 12.7749 24.95 12.7749ZM17.45 19.0249C16.8319 19.0249 16.2278 19.2082 15.7139 19.5516C15.2 19.8949 14.7994 20.383 14.5629 20.954C14.3264 21.525 14.2645 22.1534 14.3851 22.7596C14.5056 23.3658 14.8033 23.9226 15.2403 24.3596C15.6773 24.7967 16.2342 25.0943 16.8404 25.2149C17.4465 25.3354 18.0749 25.2736 18.6459 25.037C19.2169 24.8005 19.705 24.4 20.0484 23.8861C20.3917 23.3722 20.575 22.768 20.575 22.1499C20.575 21.3211 20.2458 20.5262 19.6597 19.9402C19.0737 19.3541 18.2788 19.0249 17.45 19.0249ZM17.45 24.0249C17.0792 24.0249 16.7167 23.9149 16.4083 23.7089C16.1 23.5029 15.8597 23.21 15.7177 22.8674C15.5758 22.5248 15.5387 22.1478 15.611 21.7841C15.6834 21.4204 15.862 21.0863 16.1242 20.8241C16.3864 20.5619 16.7205 20.3833 17.0842 20.3109C17.4479 20.2386 17.8249 20.2757 18.1675 20.4176C18.5102 20.5595 18.803 20.7999 19.009 21.1082C19.215 21.4166 19.325 21.7791 19.325 22.1499C19.325 22.6472 19.1275 23.1241 18.7758 23.4757C18.4242 23.8274 17.9473 24.0249 17.45 24.0249ZM24.95 19.0249C24.3319 19.0249 23.7278 19.2082 23.2139 19.5516C22.7 19.8949 22.2994 20.383 22.0629 20.954C21.8264 21.525 21.7645 22.1534 21.8851 22.7596C22.0056 23.3658 22.3033 23.9226 22.7403 24.3596C23.1773 24.7967 23.7342 25.0943 24.3404 25.2149C24.9465 25.3354 25.5749 25.2736 26.1459 25.037C26.7169 24.8005 27.205 24.4 27.5484 23.8861C27.8917 23.3722 28.075 22.768 28.075 22.1499C28.075 21.3211 27.7458 20.5262 27.1597 19.9402C26.5737 19.3541 25.7788 19.0249 24.95 19.0249ZM24.95 24.0249C24.5792 24.0249 24.2167 23.9149 23.9083 23.7089C23.6 23.5029 23.3597 23.21 23.2177 22.8674C23.0758 22.5248 23.0387 22.1478 23.111 21.7841C23.1834 21.4204 23.362 21.0863 23.6242 20.8241C23.8864 20.5619 24.2205 20.3833 24.5842 20.3109C24.9479 20.2386 25.3249 20.2757 25.6675 20.4176C26.0102 20.5595 26.303 20.7999 26.509 21.1082C26.715 21.4166 26.825 21.7791 26.825 22.1499C26.825 22.6472 26.6275 23.1241 26.2758 23.4757C25.9242 23.8274 25.4473 24.0249 24.95 24.0249Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30671"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30671"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30671"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30671"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30671"
            result="effect2_dropShadow_9470_30671"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30671"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.SERIES ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30678)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          stroke="#F96343"
          stroke-width="1.4"
          d="M13.7 14.0249H14.95V22.7749M14.95 22.7749H13.7M14.95 22.7749H16.2M17.45 14.0249H22.45V18.3999H18.075V22.7749H23.075M24.325 14.0249H28.7V18.3999M28.7 18.3999H24.95M28.7 18.3999V22.7749H24.325"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30678"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30678"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30678"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30678"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30678"
            result="effect2_dropShadow_9470_30678"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30678"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.ARRAYS ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30999)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            width="32"
            x="5.20001"
            y="2.19971"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#FF5533"
          d="M23.575 11.8662V13.4495H25.95V22.9495H23.575V24.5329H27.5333V11.8662H23.575ZM14.8667 24.5329H18.825V22.9495H16.45V13.4495H18.825V11.8662H14.8667V24.5329Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30999"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30999"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30999"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30999"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30999"
            result="effect2_dropShadow_9470_30999"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30999"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.STRINGS ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_31004)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            x="5.20001"
            y="2.19971"
            width="32"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#FF5533"
          d="M15.2 24.1997H17.2V25.1997H15.2C14.9348 25.1997 14.6804 25.0943 14.4929 24.9068C14.3054 24.7193 14.2 24.4649 14.2 24.1997V22.1997H15.2V24.1997ZM18.7 16.6997V20.6997H16.2C15.9348 20.6997 15.6804 20.5943 15.4929 20.4068C15.3054 20.2193 15.2 19.9649 15.2 19.6997V18.6997C15.2 18.4345 15.3054 18.1801 15.4929 17.9926C15.6804 17.8051 15.9348 17.6997 16.2 17.6997H17.7V16.6997H15.7V15.6997H17.7C18.2515 15.6997 18.7 16.1482 18.7 16.6997ZM17.7 18.6997H16.2V19.6997H17.7V18.6997ZM15.2 12.1997H17.2V11.1997H15.2C14.9348 11.1997 14.6804 11.3051 14.4929 11.4926C14.3054 11.6801 14.2 11.9345 14.2 12.1997V14.1997H15.2V12.1997ZM27.2 11.1997H25.2V12.1997H27.2V14.1997H28.2V12.1997C28.2 11.9345 28.0947 11.6801 27.9071 11.4926C27.7196 11.3051 27.4652 11.1997 27.2 11.1997ZM27.2 24.1997H25.2V25.1997H27.2C27.4652 25.1997 27.7196 25.0943 27.9071 24.9068C28.0947 24.7193 28.2 24.4649 28.2 24.1997V22.1997H27.2V24.1997ZM27.2 20.6997V19.6997H25.2V16.6997H27.2V15.6997H25.2C24.649 15.6997 24.2 16.1482 24.2 16.6997V19.6997C24.2 20.2512 24.649 20.6997 25.2 20.6997H27.2ZM23.2 16.6997V19.6997C23.2 20.2512 22.7515 20.6997 22.2 20.6997H19.7V14.1997H20.7V15.6997H22.2C22.7515 15.6997 23.2 16.1482 23.2 16.6997ZM22.2 16.6997H20.7V19.6997H22.2V16.6997Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_31004"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_31004"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31004"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_31004"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31004"
            result="effect2_dropShadow_9470_31004"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31004"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.SORTING ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_31011)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            width="32"
            x="5.20001"
            y="2.19971"
            height="32"
            fill="white"
          />
        )}
        <g filter="url(#filter1_dd_9470_31011)">
          <path
            fill="#F96343"
            d="M27.6002 21.3997V22.9997H18.0002V24.5997H16.4002V22.9997H14.8002V21.3997H16.4002V19.7997H18.0002V21.3997H27.6002ZM18.0002 19.7997H19.6002V18.1997H18.0002V19.7997ZM18.0002 24.5997H19.6002V26.1997H18.0002V24.5997ZM14.8002 13.3997V14.9997H24.4002V16.5997H22.8002V18.1997H24.4002V16.5997H26.0002V14.9997H27.6002V13.3997H26.0002V11.7997H24.4002V10.1997H22.8002V11.7997H24.4002V13.3997H14.8002Z"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_31011"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_31011"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31011"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_31011"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31011"
            result="effect2_dropShadow_9470_31011"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31011"
          />
        </filter>
        <filter
          width="24"
          x="9.19979"
          y="6.99961"
          height="24.0002"
          id="filter1_dd_9470_31011"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="0.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31011"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="1.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31011"
            result="effect2_dropShadow_9470_31011"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31011"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.SEARCHING ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_31018)">
        {Props.from != "SOADashboard" && (
          <rect x="5.20001" y="2" width="32" height="32" rx="16" fill="white" />
        )}
        <g filter="url(#filter1_dd_9470_31018)">
          <path
            fill="#F96343"
            d="M16.4002 10H22.8002V11.6H16.4002V10ZM14.8002 13.2V11.6H16.4002V13.2H14.8002ZM14.8002 19.6H13.2002V13.2H14.8002V19.6ZM16.4002 21.2H14.8002V19.6H16.4002V21.2ZM22.8002 21.2V22.8H16.4002V21.2H22.8002ZM24.4002 19.6H22.8002V21.2H24.4002V22.8H26.0002V24.4H27.6002V26H29.2002V24.4H27.6002V22.8H26.0002V21.2H24.4002V19.6ZM24.4002 13.2H26.0002V19.6H24.4002V13.2ZM24.4002 13.2V11.6H22.8002V13.2H24.4002Z"
          />
        </g>
      </g>
      <defs>
        <filter
          y="0.4"
          x="0.400012"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_31018"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_31018"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31018"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_31018"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31018"
            result="effect2_dropShadow_9470_31018"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31018"
          />
        </filter>
        <filter
          width="24"
          y="6.7999"
          x="9.19982"
          height="24.0002"
          id="filter1_dd_9470_31018"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="0.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31018"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="1.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31018"
            result="effect2_dropShadow_9470_31018"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31018"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.RECURSION ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_31023)">
        {Props.from != "SOADashboard" && (
          <rect x="5.20001" y="2" width="32" height="32" rx="16" fill="white" />
        )}
        <path
          fill="#FF5533"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.0333 14.4585C16.094 14.4585 15.1932 14.8316 14.529 15.4958C13.8648 16.16 13.4917 17.0609 13.4917 18.0002C13.4917 18.9395 13.8648 19.8403 14.529 20.5045C15.1932 21.1687 16.094 21.5418 17.0333 21.5418C17.5308 21.5418 17.9042 21.4527 18.2058 21.3052C18.5075 21.1585 18.7717 20.9368 19.0275 20.6252C19.4775 20.0752 19.8467 19.3268 20.3333 18.341C20.4305 18.1438 20.5333 17.9371 20.6417 17.721L20.925 17.146C21.4092 16.1618 21.8558 15.2543 22.4058 14.5835C22.7475 14.166 23.1475 13.8143 23.6475 13.571C24.1475 13.3277 24.7133 13.2085 25.3667 13.2085C26.1259 13.2085 26.8743 13.3889 27.5501 13.7349C28.226 14.0809 28.8099 14.5825 29.2539 15.1984C29.6978 15.8144 29.989 16.527 30.1035 17.2775C30.218 18.0281 30.1525 18.7951 29.9124 19.5154C29.6723 20.2357 29.2645 20.8886 28.7226 21.4204C28.1806 21.9521 27.5201 22.3475 26.7954 22.5739C26.0707 22.8003 25.3025 22.8512 24.5543 22.7225C23.806 22.5937 23.0991 22.289 22.4917 21.8335C22.3591 21.734 22.2714 21.586 22.2479 21.4219C22.2245 21.2578 22.2672 21.0911 22.3667 20.9585C22.4661 20.8259 22.6142 20.7382 22.7783 20.7148C22.9424 20.6913 23.1091 20.734 23.2417 20.8335C23.6906 21.1702 24.2131 21.3954 24.7662 21.4906C25.3193 21.5857 25.887 21.5481 26.4227 21.3807C26.9583 21.2134 27.4466 20.9212 27.8471 20.5281C28.2477 20.1351 28.5491 19.6525 28.7266 19.1201C28.904 18.5878 28.9525 18.0208 28.8678 17.466C28.7832 16.9113 28.5679 16.3846 28.2398 15.9293C27.9117 15.4741 27.4801 15.1033 26.9805 14.8476C26.481 14.5919 25.9278 14.4585 25.3667 14.4585C24.8692 14.4585 24.4958 14.5477 24.1942 14.6952C23.8925 14.8418 23.6283 15.0635 23.3725 15.3752C22.9225 15.9252 22.5533 16.6735 22.0667 17.6593C21.9694 17.8566 21.8667 18.0632 21.7583 18.2793L21.475 18.8543C20.9908 19.8385 20.5442 20.746 19.9942 21.4177C19.6525 21.8343 19.2525 22.186 18.7525 22.4293C18.2525 22.6727 17.6858 22.7918 17.0333 22.7918C16.2741 22.7917 15.5258 22.6112 14.85 22.2651C14.1743 21.919 13.5904 21.4174 13.1466 20.8014C12.7028 20.1854 12.4116 19.4728 12.2972 18.7223C12.1828 17.9717 12.2484 17.2047 12.4885 16.4845C12.7287 15.7643 13.1365 15.1114 13.6785 14.5797C14.2204 14.048 14.8809 13.6527 15.6056 13.4264C16.3303 13.2 17.0984 13.1491 17.8466 13.2779C18.5949 13.4066 19.3018 13.7113 19.9092 14.1668C19.9748 14.2161 20.0301 14.2779 20.0719 14.3486C20.1137 14.4192 20.1412 14.4974 20.1528 14.5787C20.1643 14.66 20.1598 14.7428 20.1393 14.8223C20.1189 14.9019 20.083 14.9766 20.0337 15.0422C19.9844 15.1079 19.9227 15.1632 19.852 15.205C19.7813 15.2468 19.7031 15.2743 19.6218 15.2858C19.5405 15.2974 19.4578 15.2929 19.3782 15.2724C19.2987 15.252 19.224 15.2161 19.1583 15.1668C18.5458 14.706 17.7998 14.4573 17.0333 14.4585Z"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_9470_31023"
          y="0.4"
          x="0.400012"
          width="41.6"
          height="41.6"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_31023"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31023"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_31023"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31023"
            result="effect2_dropShadow_9470_31023"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31023"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.TIME_COMPLEXITY ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_31030)">
        {Props.from != "SOADashboard" && (
          <rect x="5.20001" y="2" width="32" height="32" rx="16" fill="white" />
        )}
        <path
          fill="#F96343"
          d="M26.825 13.9094V11.125C26.825 10.7935 26.6933 10.4755 26.4589 10.2411C26.2245 10.0067 25.9065 9.875 25.575 9.875H16.825C16.4935 9.875 16.1755 10.0067 15.9411 10.2411C15.7067 10.4755 15.575 10.7935 15.575 11.125V13.9375C15.5754 14.1315 15.6208 14.3227 15.7076 14.4962C15.7943 14.6697 15.9201 14.8208 16.075 14.9375L20.1586 18L16.075 21.0625C15.9201 21.1792 15.7943 21.3303 15.7076 21.5038C15.6208 21.6773 15.5754 21.8685 15.575 22.0625V24.875C15.575 25.2065 15.7067 25.5245 15.9411 25.7589C16.1755 25.9933 16.4935 26.125 16.825 26.125H25.575C25.9065 26.125 26.2245 25.9933 26.4589 25.7589C26.6933 25.5245 26.825 25.2065 26.825 24.875V22.0906C26.8246 21.8974 26.7796 21.7069 26.6935 21.5338C26.6075 21.3608 26.4827 21.2099 26.3289 21.093L22.2367 18L26.3289 14.9062C26.4828 14.7895 26.6076 14.6388 26.6937 14.4659C26.7797 14.293 26.8247 14.1025 26.825 13.9094ZM16.825 11.125H25.575V13.9094L25.1242 14.25H17.2414L16.825 13.9375V11.125ZM21.2 17.2188L18.9086 15.5H23.4711L21.2 17.2188ZM25.575 24.875H16.825V22.0625L20.575 19.25V21.125C20.575 21.2908 20.6409 21.4497 20.7581 21.5669C20.8753 21.6842 21.0343 21.75 21.2 21.75C21.3658 21.75 21.5247 21.6842 21.642 21.5669C21.7592 21.4497 21.825 21.2908 21.825 21.125V19.2563L25.575 22.0906V24.875Z"
        />
      </g>
      <defs>
        <filter
          y="0.4"
          x="0.400012"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_31030"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_31030"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_31030"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_31030"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_31030"
            result="effect2_dropShadow_9470_31030"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_31030"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.TWO_POINTERS ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9471_32519)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="1.7998"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#F96343"
          d="M27.0824 13.6821C26.268 13.6821 25.4719 13.9236 24.7947 14.3761C24.1176 14.8285 23.5898 15.4716 23.2782 16.224C22.9665 16.9764 22.885 17.8043 23.0438 18.6031C23.2027 19.4018 23.5949 20.1355 24.1707 20.7114C24.7466 21.2873 25.4803 21.6794 26.2791 21.8383C27.0778 21.9972 27.9057 21.9156 28.6581 21.604C29.4105 21.2923 30.0536 20.7646 30.5061 20.0874C30.9585 19.4103 31.2 18.6142 31.2 17.7998C31.2 16.7077 30.7662 15.6604 29.994 14.8882C29.2218 14.116 28.1744 13.6821 27.0824 13.6821ZM27.0824 20.741C26.5007 20.741 25.932 20.5685 25.4483 20.2453C24.9647 19.9221 24.5877 19.4627 24.3651 18.9253C24.1425 18.3879 24.0842 17.7965 24.1977 17.226C24.3112 16.6554 24.5913 16.1314 25.0026 15.72C25.414 15.3087 25.938 15.0286 26.5086 14.9151C27.0791 14.8016 27.6705 14.8599 28.2079 15.0825C28.7453 15.3051 29.2047 15.6821 29.5279 16.1657C29.851 16.6494 30.0235 17.2181 30.0235 17.7998C30.0235 18.5798 29.7137 19.3279 29.1621 19.8795C28.6105 20.4311 27.8624 20.741 27.0824 20.741ZM15.3177 13.6821C14.5033 13.6821 13.7072 13.9236 13.03 14.3761C12.3529 14.8285 11.8251 15.4716 11.5135 16.224C11.2018 16.9764 11.1203 17.8043 11.2791 18.6031C11.438 19.4018 11.8302 20.1355 12.406 20.7114C12.9819 21.2873 13.7156 21.6794 14.5143 21.8383C15.3131 21.9972 16.141 21.9156 16.8934 21.604C17.6458 21.2923 18.2889 20.7646 18.7414 20.0874C19.1938 19.4103 19.4353 18.6142 19.4353 17.7998C19.4353 16.7077 19.0015 15.6604 18.2293 14.8882C17.4571 14.116 16.4097 13.6821 15.3177 13.6821ZM15.3177 20.741C14.736 20.741 14.1673 20.5685 13.6836 20.2453C13.2 19.9221 12.823 19.4627 12.6004 18.9253C12.3778 18.3879 12.3195 17.7965 12.433 17.226C12.5465 16.6554 12.8266 16.1314 13.2379 15.72C13.6493 15.3087 14.1733 15.0286 14.7439 14.9151C15.3144 14.8016 15.9058 14.8599 16.4432 15.0825C16.9806 15.3051 17.44 15.6821 17.7632 16.1657C18.0863 16.6494 18.2588 17.2181 18.2588 17.7998C18.2588 18.5798 17.949 19.3279 17.3974 19.8795C16.8458 20.4311 16.0977 20.741 15.3177 20.741Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.199805"
          width="41.6"
          height="41.6"
          id="filter0_dd_9471_32519"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9471_32519"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9471_32519"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9471_32519"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9471_32519"
            result="effect2_dropShadow_9471_32519"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_9471_32519"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.SLIDING_WINDOW ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30690)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="1.7998"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#F96343"
          d="M28.075 10.9248H14.325C13.9935 10.9248 13.6755 11.0565 13.4411 11.2909C13.2067 11.5253 13.075 11.8433 13.075 12.1748V23.4248C13.075 23.7563 13.2067 24.0743 13.4411 24.3087C13.6755 24.5431 13.9935 24.6748 14.325 24.6748H28.075C28.4065 24.6748 28.7245 24.5431 28.9589 24.3087C29.1933 24.0743 29.325 23.7563 29.325 23.4248V12.1748C29.325 11.8433 29.1933 11.5253 28.9589 11.2909C28.7245 11.0565 28.4065 10.9248 28.075 10.9248ZM14.325 12.1748H17.45V23.4248H14.325V12.1748ZM28.075 23.4248H18.7V12.1748H28.075V23.4248Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.199805"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30690"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30690"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30690"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30690"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30690"
            result="effect2_dropShadow_9470_30690"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30690"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.PREFIX_ARRAY ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9471_32396)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="1.7998"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#F96343"
          d="M14.5734 17.7998C14.8383 18.0177 15.0517 18.2914 15.1984 18.6014C15.5734 19.3748 15.5734 20.3201 15.5734 21.2373C15.5734 23.1365 15.6516 24.0498 17.4484 24.0498C17.6142 24.0498 17.7732 24.1157 17.8904 24.2329C18.0076 24.3501 18.0734 24.509 18.0734 24.6748C18.0734 24.8406 18.0076 24.9995 17.8904 25.1167C17.7732 25.234 17.6142 25.2998 17.4484 25.2998C16.0828 25.2998 15.1578 24.8201 14.6984 23.8732C14.3234 23.0998 14.3234 22.1545 14.3234 21.2373C14.3234 19.3381 14.2453 18.4248 12.4484 18.4248C12.2827 18.4248 12.1237 18.359 12.0065 18.2417C11.8893 18.1245 11.8234 17.9656 11.8234 17.7998C11.8234 17.634 11.8893 17.4751 12.0065 17.3579C12.1237 17.2407 12.2827 17.1748 12.4484 17.1748C14.2453 17.1748 14.3234 16.2615 14.3234 14.3623C14.3234 13.4467 14.3234 12.4998 14.6984 11.7264C15.1594 10.7795 16.0844 10.2998 17.45 10.2998C17.6157 10.2998 17.7747 10.3657 17.8919 10.4829C18.0091 10.6001 18.075 10.759 18.075 10.9248C18.075 11.0906 18.0091 11.2495 17.8919 11.3667C17.7747 11.484 17.6157 11.5498 17.45 11.5498C15.6531 11.5498 15.575 12.4631 15.575 14.3623C15.575 15.2779 15.575 16.2248 15.2 16.9982C15.0528 17.3084 14.8389 17.5821 14.5734 17.7998ZM29.95 17.1748C28.1531 17.1748 28.075 16.2615 28.075 14.3623C28.075 13.4467 28.075 12.4998 27.7 11.7264C27.2406 10.7795 26.3156 10.2998 24.95 10.2998C24.7842 10.2998 24.6253 10.3657 24.508 10.4829C24.3908 10.6001 24.325 10.759 24.325 10.9248C24.325 11.0906 24.3908 11.2495 24.508 11.3667C24.6253 11.484 24.7842 11.5498 24.95 11.5498C26.7469 11.5498 26.825 12.4631 26.825 14.3623C26.825 15.2779 26.825 16.2248 27.2 16.9982C27.3467 17.3082 27.5601 17.5819 27.825 17.7998C27.5601 18.0177 27.3467 18.2914 27.2 18.6014C26.825 19.3748 26.825 20.3201 26.825 21.2373C26.825 23.1365 26.7469 24.0498 24.95 24.0498C24.7842 24.0498 24.6253 24.1157 24.508 24.2329C24.3908 24.3501 24.325 24.509 24.325 24.6748C24.325 24.8406 24.3908 24.9995 24.508 25.1167C24.6253 25.234 24.7842 25.2998 24.95 25.2998C26.3156 25.2998 27.2406 24.8201 27.7 23.8732C28.075 23.0998 28.075 22.1545 28.075 21.2373C28.075 19.3381 28.1531 18.4248 29.95 18.4248C30.1157 18.4248 30.2747 18.359 30.3919 18.2417C30.5091 18.1245 30.575 17.9656 30.575 17.7998C30.575 17.634 30.5091 17.4751 30.3919 17.3579C30.2747 17.2407 30.1157 17.1748 29.95 17.1748Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.199805"
          width="41.6"
          height="41.6"
          id="filter0_dd_9471_32396"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9471_32396"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9471_32396"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9471_32396"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9471_32396"
            result="effect2_dropShadow_9471_32396"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9471_32396"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.HASHING ? (
    <svg
      width="38"
      height="37"
      fill="none"
      viewBox="0 0 38 37"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30647)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="1.6001"
            width="32"
            x="3.20001"
            height="32"
            fill="white"
          />
        )}
        <g filter="url(#filter1_dd_9470_30647)">
          <path
            stroke="#F96343"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.8667 15.6001H24.5334M13.8667 19.6001H24.5334M17.8667 11.6001L16.5334 23.6001M21.8667 11.6001L20.5334 23.6001"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0.800012"
          width="36.8"
          height="36.8"
          y="9.75728e-05"
          id="filter0_dd_9470_30647"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="0.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30647"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="1.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30647"
            result="effect2_dropShadow_9470_30647"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30647"
          />
        </filter>
        <filter
          y="7.6001"
          width="22"
          x="8.20001"
          height="22"
          id="filter1_dd_9470_30647"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30647"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30647"
            result="effect2_dropShadow_9470_30647"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30647"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.LINKED_LIST ? (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1340_27794)">
        <rect
          x="4.19995"
          y="1.3999"
          width="28"
          height="28"
          rx="14"
          fill="white"
        />
        <g clip-path="url(#clip0_1340_27794)">
          <path
            d="M16.8875 16.056C17.1693 16.4328 17.5288 16.7445 17.9417 16.9701C18.3547 17.1957 18.8113 17.3299 19.2806 17.3635C19.7499 17.3971 20.2209 17.3294 20.6618 17.1649C21.1026 17.0005 21.5029 16.7431 21.8356 16.4104L23.8043 14.4416C24.402 13.8228 24.7328 12.9939 24.7253 12.1336C24.7178 11.2733 24.3727 10.4503 23.7644 9.84192C23.156 9.23354 22.333 8.88846 21.4727 8.88098C20.6123 8.87351 19.7835 9.20424 19.1646 9.80195L18.0359 10.9241"
            stroke="#F96343"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.5125 14.7436C19.2307 14.3668 18.8711 14.0551 18.4582 13.8295C18.0453 13.6039 17.5887 13.4697 17.1194 13.4361C16.6501 13.4025 16.179 13.4702 15.7382 13.6347C15.2974 13.7991 14.897 14.0564 14.5644 14.3892L12.5956 16.358C11.9979 16.9768 11.6672 17.8057 11.6747 18.666C11.6822 19.5263 12.0272 20.3493 12.6356 20.9577C13.244 21.566 14.067 21.9111 14.9273 21.9186C15.7876 21.9261 16.6165 21.5954 17.2353 20.9976L18.3575 19.8755"
            stroke="#F96343"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_1340_27794"
          x="-4.87566e-05"
          y="-9.76324e-05"
          width="36.4"
          height="36.4"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1340_27794"
          />
          <feOffset dy="1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1340_27794"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.4"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1340_27794"
          />
          <feOffset dy="2.8" />
          <feGaussianBlur stdDeviation="2.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1340_27794"
            result="effect2_dropShadow_1340_27794"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1340_27794"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1340_27794">
          <rect
            width="15.75"
            height="15.75"
            fill="white"
            transform="translate(10.325 7.5249)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.STACK ? (
    <svg
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30658)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="1.6001"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          stroke="#F96343"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M30.2 19.6001C30.2 21.0001 30.2 21.7001 29.927 22.2351C29.6874 22.7052 29.3051 23.0875 28.835 23.3271C28.3 23.6001 27.6 23.6001 26.2 23.6001H16.2C14.8 23.6001 14.1 23.6001 13.565 23.3271C13.0945 23.0876 12.7119 22.7054 12.472 22.2351C12.2 21.7001 12.2 21.0001 12.2 19.6001M15.2 19.6001H27.2M15.2 15.6001H27.2M15.2 11.6001H27.2"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          width="41.6"
          height="41.6"
          y="9.76324e-05"
          id="filter0_dd_9470_30658"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30658"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30658"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30658"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30658"
            result="effect2_dropShadow_9470_30658"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30658"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.QUEUE ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30707)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <path
          stroke="#F96343"
          stroke-width="0.8"
          d="M22.2532 14.1035L22.5858 14.3257L22.2532 14.1035C22.114 14.3118 21.9162 14.4741 21.6847 14.57C21.4533 14.6659 21.1986 14.6909 20.9529 14.6421C20.7072 14.5932 20.4815 14.4726 20.3043 14.2954C20.1272 14.1183 20.0065 13.8926 19.9577 13.6469C19.9088 13.4011 19.9339 13.1465 20.0298 12.915C20.1256 12.6836 20.288 12.4857 20.4963 12.3465C20.7046 12.2074 20.9495 12.1331 21.2 12.1331C21.9041 12.1331 22.4667 12.6957 22.4667 13.3997C22.4667 13.6503 22.3924 13.8952 22.2532 14.1035ZM14.1 22.5664V22.1664H13.7H13.2667V18.8164C13.2667 18.3457 13.6459 17.9664 14.1167 17.9664H16.6167C17.0874 17.9664 17.4667 18.3457 17.4667 18.8164V22.1664H17.0333H16.6333V22.5664V26.3331H14.1V22.5664ZM19.9333 20.8997V20.4997H19.5333H19.1V17.1497C19.1 16.679 19.4792 16.2997 19.95 16.2997H22.45C22.9208 16.2997 23.3 16.679 23.3 17.1497V20.4997H22.8667H22.4667V20.8997V24.6664H19.9333V20.8997ZM25.7667 19.2331V18.8331H25.3667H24.9333V15.4831C24.9333 15.0123 25.3126 14.6331 25.7833 14.6331H28.2833C28.7541 14.6331 29.1333 15.0123 29.1333 15.4831V18.8331H28.7H28.3V19.2331V22.9997H25.7667V19.2331ZM14.1 15.0664C14.1 14.3707 14.6709 13.7997 15.3667 13.7997C16.0708 13.7997 16.6333 14.3623 16.6333 15.0664C16.6333 15.7692 16.0637 16.3331 15.3667 16.3331C14.6709 16.3331 14.1 15.7622 14.1 15.0664ZM25.7667 11.7331C25.7667 11.0373 26.3376 10.4664 27.0333 10.4664C27.7374 10.4664 28.3 11.029 28.3 11.7331C28.3 12.4359 27.7304 12.9997 27.0333 12.9997C26.3376 12.9997 25.7667 12.4288 25.7667 11.7331Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30707"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30707"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30707"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30707"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30707"
            result="effect2_dropShadow_9470_30707"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30707"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.TREE ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30712)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <g filter="url(#filter1_dd_9470_30712)">
          <path
            fill="#F96343"
            d="M14.0004 11.1997H18.8004V14.3997H14.0004V11.1997ZM23.6004 16.7997H28.4004V19.9997H23.6004V16.7997ZM23.6004 22.3997H28.4004V25.5997H23.6004V22.3997ZM22.0004 19.1997H17.2004V23.1997H22.0004V24.7997H15.6004V15.9997H17.2004V17.5997H22.0004V19.1997Z"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30712"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30712"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30712"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30712"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30712"
            result="effect2_dropShadow_9470_30712"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30712"
          />
        </filter>
        <filter
          y="7.1998"
          width="24"
          x="9.20004"
          height="24.0002"
          id="filter1_dd_9470_30712"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="0.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30712"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="1.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30712"
            result="effect2_dropShadow_9470_30712"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30712"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.BACKTRACKING ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30712)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.3999"
            width="32"
            x="5.20001"
            height="32"
            fill="white"
          />
        )}
        <g filter="url(#filter1_dd_9470_30712)">
          <path
            fill="#F96343"
            d="M14.0004 11.1997H18.8004V14.3997H14.0004V11.1997ZM23.6004 16.7997H28.4004V19.9997H23.6004V16.7997ZM23.6004 22.3997H28.4004V25.5997H23.6004V22.3997ZM22.0004 19.1997H17.2004V23.1997H22.0004V24.7997H15.6004V15.9997H17.2004V17.5997H22.0004V19.1997Z"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30712"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30712"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30712"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30712"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30712"
            result="effect2_dropShadow_9470_30712"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30712"
          />
        </filter>
        <filter
          y="7.1998"
          width="24"
          x="9.20004"
          height="24.0002"
          id="filter1_dd_9470_30712"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="0.8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30712"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.8" />
          <feGaussianBlur stdDeviation="1.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30712"
            result="effect2_dropShadow_9470_30712"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30712"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.GRAPH ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30723)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            width="32"
            x="5.20001"
            y="2.19971"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#FF5533"
          d="M24.2 18.0347L27.38 12.5372L28.6775 13.2872L24.755 20.0747L19.8725 17.2622L16.295 23.4497H28.7V24.9497H13.7V11.4497H15.2V22.3547L19.325 15.1997L24.2 18.0347Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30723"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30723"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30723"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30723"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30723"
            result="effect2_dropShadow_9470_30723"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30723"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.GREEDY_ALGORITHM ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30729)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            width="32"
            x="5.20001"
            y="2.19971"
            height="32"
            fill="white"
          />
        )}
        <path
          stroke="#F96343"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19.95 9.86621V11.5329M22.45 9.86621V11.5329M17.8667 13.6162H16.2M17.8667 16.1162H16.2M26.2 13.6162H24.5333M26.2 16.1162H24.5333M21.2 24.0329C21.5883 24.0329 21.7825 24.0329 21.9358 24.097C22.1398 24.1814 22.3019 24.3433 22.3867 24.547C22.45 24.7004 22.45 24.8945 22.45 25.2829C22.45 25.6712 22.45 25.8654 22.3858 26.0187C22.3015 26.2226 22.1396 26.3848 21.9358 26.4695C21.7825 26.5329 21.5883 26.5329 21.2 26.5329C20.8117 26.5329 20.6175 26.5329 20.4642 26.4695C20.2602 26.3852 20.0981 26.2225 20.0133 26.0187C19.95 25.8654 19.95 25.6712 19.95 25.2829C19.95 24.8945 19.95 24.7004 20.0142 24.547C20.0986 24.3431 20.2604 24.181 20.4642 24.0962C20.6175 24.0329 20.8117 24.0329 21.2 24.0329ZM21.2 24.0329V18.1995M22.3108 11.5329H20.0892C19.0417 11.5329 18.5167 11.5329 18.1917 11.8579C17.8667 12.1845 17.8667 12.7079 17.8667 13.7562V15.9779C17.8667 17.0254 17.8667 17.5495 18.1917 17.8754C18.5175 18.2004 19.0417 18.2004 20.0892 18.2004H22.3108C23.3583 18.2004 23.8825 18.2004 24.2083 17.8754C24.5333 17.5495 24.5333 17.0254 24.5333 15.9779V13.7554C24.5333 12.7079 24.5333 12.1837 24.2083 11.8587C23.8825 11.5329 23.3583 11.5329 22.3108 11.5329ZM14.2142 26.4695C14.3675 26.5329 14.5617 26.5329 14.95 26.5329C15.3383 26.5329 15.5325 26.5329 15.6858 26.4695C15.8896 26.3848 16.0515 26.2226 16.1358 26.0187C16.2 25.8654 16.2 25.6712 16.2 25.2829C16.2 24.8945 16.2 24.7004 16.1367 24.547C16.0519 24.3433 15.8898 24.1814 15.6858 24.097C15.5325 24.0329 15.3383 24.0329 14.95 24.0329C14.5617 24.0329 14.3675 24.0329 14.2142 24.0962C14.0104 24.181 13.8486 24.3431 13.7642 24.547C13.7 24.7004 13.7 24.8945 13.7 25.2829C13.7 25.6712 13.7 25.8654 13.7633 26.0187C13.8481 26.2225 14.0102 26.3852 14.2142 26.4695Z"
        />
        <path
          stroke="#F96343"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M14.95 24.0329C14.95 22.8629 14.95 22.277 15.2308 21.857C15.3525 21.675 15.5088 21.5187 15.6908 21.397C16.1108 21.1162 16.6967 21.1162 17.8667 21.1162H24.5333C25.7033 21.1162 26.2892 21.1162 26.7092 21.397C26.8908 21.5187 27.0475 21.6754 27.1692 21.857C27.45 22.277 27.45 22.8629 27.45 24.0329M27.45 24.0329C27.8383 24.0329 28.0325 24.0329 28.1858 24.097C28.3898 24.1814 28.5519 24.3433 28.6367 24.547C28.7 24.7004 28.7 24.8945 28.7 25.2829C28.7 25.6712 28.7 25.8654 28.6358 26.0187C28.5515 26.2226 28.3896 26.3848 28.1858 26.4695C28.0325 26.5329 27.8383 26.5329 27.45 26.5329C27.0617 26.5329 26.8675 26.5329 26.7142 26.4695C26.5102 26.3852 26.3481 26.2225 26.2633 26.0187C26.2 25.8654 26.2 25.6712 26.2 25.2829C26.2 24.8945 26.2 24.7004 26.2642 24.547C26.3486 24.3431 26.5104 24.181 26.7142 24.0962C26.8675 24.0329 27.0617 24.0329 27.45 24.0329Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30729"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30729"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30729"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30729"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30729"
            result="effect2_dropShadow_9470_30729"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30729"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.DYNAMIC_PROGRAMMING ? (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9470_30734)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            width="32"
            x="5.20001"
            y="2.19971"
            height="32"
            fill="white"
          />
        )}
        <path
          fill="#FF5533"
          d="M23.285 19.6997L21.99 20.9947L22.7 21.6997L24.7 19.6997L22.7 17.6997L21.99 18.4047L23.285 19.6997ZM19.115 19.6997L20.41 18.4047L19.7 17.6997L17.7 19.6997L19.7 21.6997L20.41 20.9947L19.115 19.6997Z"
        />
        <path
          fill="#FF5533"
          d="M17.7 14.6997C17.9762 14.6997 18.2 14.4758 18.2 14.1997C18.2 13.9236 17.9762 13.6997 17.7 13.6997C17.4239 13.6997 17.2 13.9236 17.2 14.1997C17.2 14.4758 17.4239 14.6997 17.7 14.6997Z"
        />
        <path
          fill="#FF5533"
          d="M16.2 14.6997C16.4762 14.6997 16.7 14.4758 16.7 14.1997C16.7 13.9236 16.4762 13.6997 16.2 13.6997C15.9239 13.6997 15.7 13.9236 15.7 14.1997C15.7 14.4758 15.9239 14.6997 16.2 14.6997Z"
        />
        <path
          fill="#FF5533"
          d="M27.2 12.1997H15.2C14.6485 12.1997 14.2 12.6487 14.2 13.1997V23.1997C14.2 23.7512 14.6485 24.1997 15.2 24.1997H27.2C27.7515 24.1997 28.2 23.7512 28.2 23.1997V13.1997C28.2 12.6487 27.7515 12.1997 27.2 12.1997ZM27.2 13.1997V15.1997H15.2V13.1997H27.2ZM15.2 23.1997V16.1997H27.2V23.1997H15.2Z"
        />
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.599707"
          width="41.6"
          height="41.6"
          id="filter0_dd_9470_30734"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_30734"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_30734"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_30734"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_30734"
            result="effect2_dropShadow_9470_30734"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_30734"
          />
        </filter>
      </defs>
    </svg>
  ) : Props.icon === constants.TOPICS.PICK_ONE ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 17.5L17.5 15L15 12.5M17.5 15H15.4741C14.6914 15 14.3001 15 13.9448 14.8921C13.6304 14.7966 13.3378 14.64 13.0839 14.4314C12.7971 14.1956 12.58 13.87 12.1459 13.2188L11.9444 12.9167M15 7.5L17.5 5L15 2.5M17.5 5H15.4741C14.6914 5 14.3001 5 13.9448 5.10788C13.6304 5.20338 13.3378 5.35995 13.0839 5.56864C12.7971 5.80436 12.58 6.12998 12.1459 6.7812L7.85413 13.2188C7.41998 13.87 7.20291 14.1956 6.9161 14.4314C6.6622 14.64 6.36964 14.7966 6.05517 14.8921C5.69995 15 5.30861 15 4.52593 15H2.5M2.5 5H4.52593C5.30861 5 5.69995 5 6.05517 5.10788C6.36964 5.20338 6.6622 5.35995 6.9161 5.56864C7.20291 5.80436 7.41998 6.12997 7.85413 6.7812L8.05556 7.08333" stroke="#1D2939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ) : (
    <svg
      width="42"
      height="43"
      fill="none"
      viewBox="0 0 42 43"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_default_9470)">
        {Props.from != "SOADashboard" && (
          <rect
            rx="16"
            y="2.2"
            width="32"
            x="5.2"
            height="32"
            fill="white"
          />
        )}
        <g transform="translate(14 11)">
          <path
            d="M4.6665 9.33268V10.966C4.6665 11.6194 4.6665 11.9461 4.79366 12.1957C4.90552 12.4152 5.08399 12.5937 5.30351 12.7055C5.55308 12.8327 5.87978 12.8327 6.53317 12.8327H10.9665C11.6199 12.8327 11.9466 12.8327 12.1962 12.7055C12.4157 12.5937 12.5942 12.4152 12.706 12.1957C12.8332 11.9461 12.8332 11.6194 12.8332 10.966V6.53268C12.8332 5.87929 12.8332 5.55259 12.706 5.30303C12.5942 5.0835 12.4157 4.90503 12.1962 4.79317C11.9466 4.66602 11.6199 4.66602 10.9665 4.66602H9.33317M3.03317 9.33268H7.4665C8.1199 9.33268 8.4466 9.33268 8.69616 9.20552C8.91568 9.09367 9.09416 8.91519 9.20601 8.69567C9.33317 8.44611 9.33317 8.11941 9.33317 7.46602V3.03268C9.33317 2.37929 9.33317 2.05259 9.20601 1.80303C9.09416 1.5835 8.91568 1.40503 8.69616 1.29317C8.4466 1.16602 8.1199 1.16602 7.4665 1.16602H3.03317C2.37978 1.16602 2.05308 1.16602 1.80351 1.29317C1.58399 1.40503 1.40552 1.5835 1.29366 1.80303C1.1665 2.05259 1.1665 2.37929 1.1665 3.03268V7.46602C1.1665 8.11941 1.1665 8.44611 1.29366 8.69567C1.40552 8.91519 1.58399 9.09367 1.80351 9.20552C2.05308 9.33268 2.37978 9.33268 3.03317 9.33268Z"
            stroke="#E54B2A"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0.400012"
          y="0.799902"
          width="41.6"
          height="41.6"
          id="filter0_dd_default_9470"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9470_default"
          />
          <feOffset dy="1.6" />
          <feGaussianBlur stdDeviation="1.6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9470_default"
          />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="1.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_9470_default"
          />
          <feOffset dy="3.2" />
          <feGaussianBlur stdDeviation="3.2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9470_default"
            result="effect2_dropShadow_9470_default"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_9470_default"
          />
        </filter>
      </defs>
    </svg>
  );
}

